<h1 mat-dialog-title>Search organization</h1>

<div mat-dialog-content>
  <mat-form-field class="example-full-width">
    <mat-label>Filter: Name</mat-label>
    <input matInput placeholder="Name" (input)="onChange($event.target['value'])">
  </mat-form-field>

  <lib-data-table class="data-table" [columns]="columns" [data]="organizations$ | async" [showFilter]="false" [showPaginator]="false" (selectRow)="selectOrganization($event)"></lib-data-table>
  @if (isLoading) {
    <mat-progress-spinner class="auto-center" mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
  }

</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="">Cancel</button>
</div>